import { BaseFoundationProject } from '@lfx/core/gql/services/inputs/base-foundation-project';

export interface SecurityStatisticsInput extends BaseFoundationProject {
  yearType: string;
}
